import { Component, Input } from '@angular/core';

import { CmpsScorecardPillarInformationData } from './scorecard-pillar-information.metadata';

@Component({
    selector: 'cmps-scorecard-pillar-information',
    template: `
        <div class="cmps-scorecard-pillar-information--container">
            <div class="cmps-scorecard-pillar-information--progress-bar">
                <ng-container *ngFor="let i of data">
                    <ng-template #performanceTooltip>
                        <ng-container *ngFor="let n of i.tooltipData">
                            <div
                                class="cmps-scorecard-pillar-information--tooltip-content"
                            >
                                <div
                                    class="cmps-scorecard-pillar-information--child"
                                >
                                    <strong>{{ n.title }}</strong>
                                </div>
                                <span
                                    class="cmps-scorecard-pillar-information--child"
                                    >{{ n.number }}</span
                                >
                            </div>
                        </ng-container>
                    </ng-template>
                    <div
                        class="cmps-scorecard-pillar-information--progress-bar-filled"
                        [cmpsTooltipTrigger]="performanceTooltip"
                        placement="top-center"
                        [style.width]="i.percent"
                        [style.backgroundColor]="i.backgroundColor"
                    >
                        <span>{{ i.labelValue }}</span>
                    </div>
                </ng-container>
            </div>
            <div
                class="cmps-scorecard-pillar-information--legend"
                *ngFor="let i of data"
            >
                <div
                    class="cmps-scorecard-pillar-information--box"
                    [style.backgroundColor]="i.backgroundColor"
                ></div>
                <div
                    class="cmps-scorecard-pillar-information--label"
                    *ngFor="let j of i.tooltipData"
                >
                    <label class="cmps-scorecard-pillar-information--label">{{
                        j.title
                    }}</label>
                </div>
            </div>
        </div>
    `,
    host: {
        class: 'cmps-scorecard-pillar-information',
    },
})
export class CmpsScorecardPillarInformationComponent {
    @Input() label: string;
    @Input() data: CmpsScorecardPillarInformationData;
}
